{
  "status": {
    "POSTED": "مرحّل",
    "VOID": "مُبطَل"
  },
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "errors": {
    "INSUFFICIENT_FUNDS": "الرصيد في هذا الحساب غير كافٍ في ذلك التاريخ. خفّض المبلغ أو اختر حسابًا آخر.",
    "ACCOUNT_NOT_EMPTY": "ما زال في هذا الحساب رصيد. انقل الرصيد قبل أرشفته.",
    "ACCOUNT_ARCHIVED": "لا يمكن استخدام حساب مؤرشف. اختر حسابًا نشطًا.",
    "EXPENSE_VOID": "لا يمكن تعديل مصروف مُبطَل.",
    "SUPPLIER_ARCHIVED": "هذا المورد مؤرشف. استعِده أو اختر موردًا آخر.",
    "TRANSFER_DATE_IN_FUTURE": "لا يمكن أن يكون تاريخ التحويل بعد اليوم.",
    "INSUFFICIENT_FUNDS_LATER": "كان في الحساب ما يكفي في ذلك التاريخ، لكن مدفوعات لاحقة ستنزل برصيده تحت الصفر. خفّض المبلغ أو اختر تاريخًا لاحقًا.",
    "NO_ACCOUNT_CODE": "لم يعد هناك رمز متاح لحساب نقدي أو بنكي جديد. اطلب من المحاسب توسيع دليل الحسابات.",
    "TILL_DOCUMENT": "هذا المستند صادر من نقطة البيع، لذا لا يُبطَل إلا منها: أبطِل عملية البيع في نقطة البيع ما دامت ورديتها مفتوحة.",
    "ACCOUNT_NOT_EMPTY_accountingOff": "ما زال في هذا الحساب رصيد، لذا لا يمكن أرشفته. المحاسبة متوقفة لشركتك، ولا يمكن نقل الرصيد إلا بعد إعادة تشغيلها.",
    "ACCOUNT_IN_USE": "تمرّ الأموال عبر هذا الحساب من خلال {{names}}. اختر لها حسابًا آخر أولًا، ثم أرشفه.",
    "ACCOUNT_KIND_IN_USE": "لا يمكن تغيير هذا الحساب إلى ذلك النوع: يستخدمه {{names}}، ولن يناسبها بعد التغيير. انقلها إلى حساب آخر أولًا.",
    "tillNamed": "صندوق البيع {{code}}",
    "defaultFor": "الحساب الافتراضي لنوع «{{method}}»"
  },
  "treasury": {
    "title": "النقدية والبنوك",
    "subtitle": "صناديق النقد والحسابات البنكية وأجهزة البطاقات والمحافظ، بأرصدة اليوم.",
    "new": "حساب جديد",
    "newTitle": "حساب نقدي أو بنكي جديد",
    "newSubtitle": "يُنشأ له حساب في دفتر الأستاذ تلقائيًا.",
    "editTitle": "تعديل الحساب",
    "save": "حفظ الحساب",
    "actions": "إجراءات",
    "archived": "مؤرشف",
    "showArchived": "إظهار المؤرشفة",
    "total": "إجمالي الأرصدة",
    "empty": "لا توجد حسابات نقدية أو بنكية بعد.",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "entriesOf": "قيود {{name}}",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "kind": "النوع",
      "bankDetails": "البنك",
      "bankName": "البنك",
      "accountNumber": "رقم الحساب",
      "iban": "رقم الآيبان",
      "glAccount": "حساب الأستاذ",
      "balance": "الرصيد",
      "openingBalance": "الرصيد الافتتاحي",
      "openingDate": "بتاريخ"
    },
    "kind": {
      "CASH": "نقدية",
      "BANK": "حساب بنكي",
      "CARD_TERMINAL": "جهاز بطاقات",
      "MOBILE_WALLET": "محفظة إلكترونية"
    },
    "opening": {
      "title": "المبلغ الموجود في الحساب حاليًا",
      "hint": "يُرحَّل مقابل حقوق ملكية الأرصدة الافتتاحية في هذا التاريخ. اتركه فارغًا لحساب جديد فارغ."
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يعود بالإمكان استخدامه في المدفوعات أو التحويلات. لا يؤرشف إلا حساب فارغ.",
      "confirm": "أرشفة"
    },
    "errors": {
      "nameTaken": "يوجد حساب آخر بهذا الاسم.",
      "version": "عدّل شخص آخر هذا الحساب. أغلق هذه اللوحة وافتحه مرة أخرى."
    },
    "toast": {
      "created": "تمت إضافة {{name}}",
      "updated": "تم حفظ الحساب",
      "archived": "تمت أرشفة الحساب"
    }
  },
  "transfers": {
    "title": "التحويلات",
    "subtitle": "الأموال المنقولة بين حساباتك النقدية والبنكية.",
    "new": "تحويل جديد",
    "newTitle": "تحويل جديد",
    "newSubtitle": "يُرحَّل إلى دفتر الأستاذ فورًا.",
    "save": "تحويل",
    "actions": "إجراءات",
    "chooseAccount": "اختر حسابًا",
    "available": "المتاح في {{name}}:",
    "after": "بعد التحويل:",
    "overdrawn": "المبلغ أكبر من رصيد الحساب اليوم. يُرفض التحويل إن كان الرصيد في تاريخه غير كافٍ.",
    "voidNamed": "إبطال {{number}}",
    "fields": {
      "number": "الرقم",
      "date": "التاريخ",
      "from": "من",
      "to": "إلى",
      "amount": "المبلغ",
      "reference": "المرجع",
      "notes": "ملاحظات",
      "status": "الحالة"
    },
    "empty": {
      "title": "لا توجد تحويلات بعد.",
      "body": "سجّل الأموال المنقولة بين النقدية والبنك، مثل إيداع نقدي."
    },
    "void": {
      "title": "إبطال التحويل {{number}}؟",
      "body": "يُعكس قيده ويعود الرصيدان إلى ما كانا عليه.",
      "reason": "السبب",
      "confirm": "إبطال التحويل"
    },
    "toast": {
      "created": "تم ترحيل التحويل {{number}}",
      "voided": "تم إبطال التحويل {{number}}"
    },
    "fromTill": "نقطة البيع",
    "fromTillHint": "إيداع أو سحب نقدي تم في نقطة البيع، لذا لا يُبطَل من هنا."
  },
  "expenses": {
    "title": "المصروفات",
    "subtitle": "الأموال المصروفة: يُرحَّل كل مصروف إلى حسابه وإلى الحساب النقدي أو البنكي الذي دُفع منه.",
    "new": "مصروف جديد",
    "newTitle": "مصروف جديد",
    "newSubtitle": "يُخصَّص الرقم عند الحفظ.",
    "editTitle": "تعديل {{number}}",
    "editSubtitle": "تعديل المصروف",
    "save": "حفظ المصروف",
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "edit": "تعديل",
    "searchLabel": "البحث في المصروفات",
    "searchPlaceholder": "ابحث بالرقم أو الوصف أو المستفيد…",
    "clearSearch": "مسح البحث",
    "categoryFilter": "التصفية حسب الفئة",
    "allCategories": "كل الفئات",
    "paidFromFilter": "التصفية حسب حساب الدفع",
    "allPaidFrom": "كل حسابات الدفع",
    "statusFilter": "التصفية حسب الحالة",
    "allStatuses": "كل الحالات",
    "clearFilters": "مسح عوامل التصفية",
    "pageTotals_zero": "المرحّل في هذه الصفحة (لا مصروفات)",
    "pageTotals_one": "المرحّل في هذه الصفحة (مصروف واحد)",
    "pageTotals_two": "المرحّل في هذه الصفحة (مصروفان)",
    "pageTotals_few": "المرحّل في هذه الصفحة ({{n}} مصروفات)",
    "pageTotals_many": "المرحّل في هذه الصفحة ({{n}} مصروفًا)",
    "pageTotals_other": "المرحّل في هذه الصفحة ({{n}} مصروف)",
    "chooseCategory": "اختر فئة",
    "chooseSupplier": "بلا مورد",
    "clearSupplier": "بلا مورد",
    "searchCategories": "ابحث في الفئات…",
    "noCategories": "لا توجد فئات. أنشئ فئة من المصروفات › الفئات.",
    "choosePaidFrom": "اختر الحساب النقدي أو البنكي",
    "balance": "الرصيد اليوم:",
    "postsTo": "يُرحَّل إلى",
    "overridden": "(المختار أدناه)",
    "useDefault": "حساب الفئة الافتراضي ({{code}})",
    "useCategoryDefault": "الحساب الافتراضي للفئة",
    "searchAccounts": "ابحث بالرمز أو الاسم…",
    "noAccounts": "لا توجد حسابات مصروفات أو أصول.",
    "clearOverride": "استخدام الحساب الافتراضي للفئة",
    "noTax": "بلا ضريبة",
    "viewEntry": "عرض القيد",
    "posted": "مرحّل",
    "noEntry": "لا يوجد (مُبطَل)",
    "backToExpense": "العودة إلى المصروف",
    "voidTitle": "هذا المصروف مُبطَل",
    "voidReason": "السبب: {{reason}}",
    "sections": {
      "what": "المصروف",
      "amount": "المبلغ",
      "payment": "الدفع",
      "posting": "الترحيل",
      "attachments": "المرفقات"
    },
    "fields": {
      "number": "الرقم",
      "date": "التاريخ",
      "category": "الفئة",
      "description": "الوصف",
      "payee": "دُفع إلى",
      "supplier": "المورد",
      "vatin": "الرقم الضريبي للمورد",
      "reference": "المرجع",
      "amount": "المبلغ قبل الضريبة",
      "taxRate": "نسبة الضريبة",
      "net": "الصافي",
      "tax": "الضريبة",
      "total": "الإجمالي",
      "paidFrom": "دُفع من",
      "account": "الترحيل إلى حساب آخر",
      "postedTo": "رُحّل إلى",
      "journalEntry": "القيد",
      "status": "الحالة",
      "createdAt": "تاريخ الإنشاء",
      "updatedAt": "آخر تعديل"
    },
    "hints": {
      "reference": "رقم الإيصال أو الفاتورة إن وُجد.",
      "supplier": "المورد صاحب الفاتورة الضريبية، لإقرار ضريبة القيمة المضافة. لا يُسجَّل له أي مبلغ مستحق.",
      "vatin": "الرقم الضريبي {{vatin}}",
      "noVatin": "لا رقم ضريبي مسجّل لهذا المورد: لا تُسترد ضريبة المدخلات إلا بفاتورة ضريبية تحمله.",
      "amount": "تُضاف الضريبة حسب النسبة التي تختارها.",
      "account": "فقط إن كان هذا المصروف يخص حسابًا غير حساب فئته."
    },
    "errors": {
      "notSaved": "لم يُحفظ المصروف",
      "field": "راجع هذه القيمة."
    },
    "conflict": {
      "title": "عدّل شخص آخر هذا المصروف",
      "body": "لم تُحفظ تغييراتك. أعد التحميل لعرض أحدث نسخة، ثم أعد إجراء تغييراتك.",
      "reload": "تحميل أحدث نسخة"
    },
    "empty": {
      "title": "لا توجد مصروفات بعد.",
      "body": "سجّل مصروفك الأول: إيجار، كهرباء، وقود…",
      "filteredTitle": "لا توجد مصروفات مطابقة.",
      "filteredBody": "جرّب بحثًا أو فترة أخرى، أو امسح عوامل التصفية."
    },
    "void": {
      "action": "إبطال",
      "title": "إبطال المصروف {{number}}؟",
      "body": "يُعكس قيده في تاريخ المصروف كأنه لم يحدث. لا يمكن التراجع عن ذلك.",
      "reason": "السبب",
      "confirm": "إبطال المصروف"
    },
    "toast": {
      "created": "تم حفظ المصروف {{number}}",
      "updated": "تم حفظ المصروف",
      "voided": "تم إبطال المصروف {{number}}"
    },
    "stats": {
      "label": "أرقام المصروفات",
      "spent": "المنصرف هذا الشهر",
      "spentDetail": "{{month}} · {{expenses}}",
      "trend": "المصروفات المرحّلة حسب الشهر، من {{from}} إلى {{to}}",
      "posted": "المرحّلة",
      "tax": "ضريبة المدخلات",
      "taxDetail": "على المصروفات المرحّلة",
      "void": "الملغاة",
      "voidDetail": "معكوسة ومحفوظة في السجل",
      "expenses_zero": "لا مصروفات",
      "expenses_one": "مصروف واحد",
      "expenses_two": "مصروفان",
      "expenses_few": "{{n}} مصروفات",
      "expenses_many": "{{n}} مصروفًا",
      "expenses_other": "{{n}} مصروف"
    },
    "suggest": {
      "action": "اقتراح الفئة",
      "prompt": "اقترح فئة هذا المصروف.",
      "fromHistory_zero": "اختيرت {{category}}: استُخدمت لمصروفات سابقة إلى {{payee}}، آخرها في {{date}}.",
      "fromHistory_one": "اختيرت {{category}}: استُخدمت لمصروف سابق واحد إلى {{payee}} في {{date}}.",
      "fromHistory_two": "اختيرت {{category}}: استُخدمت لمصروفين سابقين إلى {{payee}}، آخرهما في {{date}}.",
      "fromHistory_few": "اختيرت {{category}}: استُخدمت لـ {{n}} مصروفات سابقة إلى {{payee}}، آخرها في {{date}}.",
      "fromHistory_many": "اختيرت {{category}}: استُخدمت لـ {{n}} مصروفًا سابقًا إلى {{payee}}، آخرها في {{date}}.",
      "fromHistory_other": "اختيرت {{category}}: استُخدمت لـ {{n}} مصروف سابق إلى {{payee}}، آخرها في {{date}}.",
      "fromAssistant": "اختار المساعد {{category}}.",
      "check": "تحقّق منها ثم احفظ.",
      "none": "لا مصروفات سابقة مدفوعة إليه. اختر الفئة بنفسك.",
      "noneAtAll": "لا اقتراح هذه المرة. اختر الفئة بنفسك.",
      "needsInput": "املأ «دُفع إلى» أولًا: يأتي الاقتراح من المصروفات السابقة المدفوعة إليه.",
      "needsInputAi": "املأ «دُفع إلى» أو الوصف أولًا.",
      "failed": "تعذّر الاقتراح. اختر الفئة بنفسك.",
      "sureness": {
        "high": "مرجّح جدًا",
        "medium": "مرجّح",
        "low": "غير متأكد"
      },
      "offerAssistant": "يقترح المساعد {{category}}. استخدمه فقط إن كان مناسبًا.",
      "use": "استخدامه",
      "fromRule": "اختيرت {{category}}."
    }
  },
  "categories": {
    "title": "فئات المصروفات",
    "subtitle": "أنواع الإنفاق، ولكل منها حساب افتراضي تُرحَّل إليه.",
    "new": "فئة جديدة",
    "newTitle": "فئة مصروفات جديدة",
    "newSubtitle": "سمِّ الفئة واختر الحساب الذي تُرحَّل إليه.",
    "editTitle": "تعديل فئة المصروفات",
    "save": "حفظ الفئة",
    "actions": "إجراءات",
    "archived": "مؤرشفة",
    "showArchived": "إظهار المؤرشفة",
    "empty": "لا توجد فئات مصروفات بعد.",
    "chooseAccount": "اختر حسابًا",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "defaultAccount": "الحساب الافتراضي"
    },
    "hints": {
      "account": "حساب مصروفات أو أصول (وليس حسابًا نقديًا أو بنكيًا). يمكن لكل مصروف اختيار حساب آخر."
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يعود بالإمكان اختيارها للمصروفات الجديدة. تحتفظ المصروفات السابقة بها.",
      "confirm": "أرشفة"
    },
    "errors": {
      "nameTaken": "توجد فئة بهذا الاسم بالفعل.",
      "account": "اختر حساب مصروفات أو أصول نشطًا، لا حسابًا نقديًا أو بنكيًا ولا حسابًا تحدد المستندات رصيده (المخزون أو الذمم المدينة أو الدائنة أو الشيكات برسم التحصيل أو الصادرة أو الدفعات المقدمة من العملاء أو المحتجزات أو ضريبة القيمة المضافة).",
      "version": "عدّل شخص آخر هذه الفئة. أغلق هذه اللوحة وافتحها مرة أخرى."
    },
    "toast": {
      "created": "تم إنشاء الفئة",
      "updated": "تم حفظ الفئة",
      "archived": "تمت أرشفة الفئة"
    }
  },
  "taxRates": {
    "title": "نسب الضريبة",
    "subtitle": "النسب المتاحة في المستندات والمصروفات. تُقترح النسبة الافتراضية على الجديد منها.",
    "new": "نسبة ضريبة جديدة",
    "newTitle": "نسبة ضريبة جديدة",
    "newSubtitle": "مثل ضريبة القيمة المضافة 5%.",
    "editTitle": "تعديل نسبة الضريبة",
    "editNotice": "يؤثر تغيير النسبة على المستندات الجديدة فقط؛ تحتفظ المستندات المحفوظة بنسبتها.",
    "save": "حفظ نسبة الضريبة",
    "actions": "إجراءات",
    "default": "افتراضية",
    "archived": "مؤرشفة",
    "showArchived": "إظهار المؤرشفة",
    "empty": "لا توجد نسب ضريبة بعد.",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "rate": "النسبة",
      "isDefault": "النسبة الافتراضية",
      "status": "الحالة",
      "category": "خانة الإقرار الضريبي"
    },
    "hints": {
      "rate": "نسبة مئوية بمنزلتين عشريتين كحد أقصى، من 0 إلى 100.",
      "default": "تُقترح على المستندات والمصروفات الجديدة. نسبة واحدة فقط تكون افتراضية.",
      "category": "طريقة الإبلاغ عن المبيعات بهذه النسبة. النسبة الأساسية أكبر من 0٪؛ ونسب الصفر والمعفاة وخارج النطاق 0٪."
    },
    "archive": {
      "title": "أرشفة {{name}}؟",
      "body": "لن يعود بالإمكان اختيارها. تحتفظ المستندات التي استخدمتها بها.",
      "confirm": "أرشفة"
    },
    "errors": {
      "nameTaken": "توجد نسبة ضريبة بهذا الاسم بالفعل.",
      "version": "عدّل شخص آخر هذه النسبة. أغلق هذه اللوحة وافتحها مرة أخرى."
    },
    "toast": {
      "created": "تم إنشاء نسبة الضريبة",
      "updated": "تم حفظ نسبة الضريبة",
      "archived": "تمت أرشفة نسبة الضريبة"
    },
    "impact": {
      "title": "تغيير {{name}}؟",
      "newDocuments": "تستخدم المستندات الجديدة النسبة الجديدة.",
      "posted": "تحتفظ المستندات المرحّلة بالنسبة التي رُحّلت بها.",
      "vatReturn": "يُجمِّع إقرار ضريبة القيمة المضافة المبالغ حسب الفئة.",
      "confirm": "تغيير نسبة الضريبة"
    },
    "category": {
      "STANDARD": "خاضعة للنسبة الأساسية",
      "ZERO": "خاضعة لنسبة الصفر",
      "EXEMPT": "معفاة",
      "OUT_OF_SCOPE": "خارج نطاق الضريبة"
    }
  },
  "recurring": {
    "title": "المصروفات المتكررة",
    "short": "المتكررة",
    "subtitle": "مصروفات تتكرر مثل الإيجار: كل موعد يصبح مصروفًا يُرحَّل تلقائيًا أو ينتظر مراجعتك.",
    "new": "مصروف متكرر جديد",
    "newTitle": "مصروف متكرر جديد",
    "newSubtitle": "أعدّ المصروف مرة واحدة، وحدّد متى يتكرر.",
    "editTitle": "تعديل {{name}}",
    "editSubtitle": "تسري التعديلات على المواعيد القادمة، وتبقى المصروفات التي أُنشئت كما هي.",
    "endedTitle": "انتهى هذا المصروف المتكرر",
    "back": "العودة إلى المصروف المتكرر",
    "save": "حفظ المصروف المتكرر",
    "makeRecurring": "اجعله متكررًا",
    "fromRecurring": "متكرر: {{name}}",
    "review": "مراجعة",
    "waiting_zero": "لا مصروفات متكررة تنتظر مراجعتك",
    "waiting_one": "مصروف متكرر واحد ينتظر مراجعتك",
    "waiting_two": "مصروفان متكرران ينتظران مراجعتك",
    "waiting_few": "{{n}} مصروفات متكررة تنتظر مراجعتك",
    "waiting_many": "{{n}} مصروفًا متكررًا تنتظر مراجعتك",
    "waiting_other": "{{n}} مصروف متكرر تنتظر مراجعتك",
    "needsAttention": "يحتاج إلى انتباه",
    "pendingCount_zero": "لا شيء ينتظر المراجعة",
    "pendingCount_one": "موعد واحد ينتظر المراجعة",
    "pendingCount_two": "موعدان ينتظران المراجعة",
    "pendingCount_few": "{{n}} مواعيد تنتظر المراجعة",
    "pendingCount_many": "{{n}} موعدًا تنتظر المراجعة",
    "pendingCount_other": "{{n}} موعد تنتظر المراجعة",
    "nextOn": "التالي في {{date}}",
    "endsOn": "في {{date}}",
    "endsAfter_zero": "بعد {{n}} مرة",
    "endsAfter_one": "بعد مرة واحدة",
    "endsAfter_two": "بعد مرتين",
    "endsAfter_few": "بعد {{n}} مرات",
    "endsAfter_many": "بعد {{n}} مرة",
    "endsAfter_other": "بعد {{n}} مرة",
    "noMore": "لا مواعيد أخرى",
    "noOccurrences": "لم يُنشأ شيء بعد. يظهر هنا كل موعد عند حلوله.",
    "searchPlaceholder": "ابحث بالاسم أو الوصف أو المستفيد",
    "searchLabel": "البحث في المصروفات المتكررة",
    "statusFilter": "الحالة",
    "scheduleText": "{{every}} {{on}}",
    "every": {
      "WEEKLY_zero": "كل {{n}} أسبوع",
      "WEEKLY_one": "أسبوعيًا",
      "WEEKLY_two": "كل أسبوعين",
      "WEEKLY_few": "كل {{n}} أسابيع",
      "WEEKLY_many": "كل {{n}} أسبوعًا",
      "WEEKLY_other": "كل {{n}} أسبوع",
      "MONTHLY_zero": "كل {{n}} شهر",
      "MONTHLY_one": "شهريًا",
      "MONTHLY_two": "كل شهرين",
      "MONTHLY_few": "كل {{n}} أشهر",
      "MONTHLY_many": "كل {{n}} شهرًا",
      "MONTHLY_other": "كل {{n}} شهر",
      "QUARTERLY_zero": "كل {{n}} ربع سنة",
      "QUARTERLY_one": "كل ربع سنة",
      "QUARTERLY_two": "كل ربعَي سنة",
      "QUARTERLY_few": "كل {{n}} أرباع سنة",
      "QUARTERLY_many": "كل {{n}} ربع سنة",
      "QUARTERLY_other": "كل {{n}} ربع سنة",
      "YEARLY_zero": "كل {{n}} سنة",
      "YEARLY_one": "سنويًا",
      "YEARLY_two": "كل سنتين",
      "YEARLY_few": "كل {{n}} سنوات",
      "YEARLY_many": "كل {{n}} سنة",
      "YEARLY_other": "كل {{n}} سنة"
    },
    "on": {
      "weekday": "يوم {{day}}",
      "day": "في اليوم {{day}}",
      "lastDay": "في آخر يوم من الشهر",
      "date": "في {{date}}"
    },
    "unit": {
      "WEEKLY_zero": "أسبوع",
      "WEEKLY_one": "أسبوع",
      "WEEKLY_two": "أسبوعان",
      "WEEKLY_few": "أسابيع",
      "WEEKLY_many": "أسبوعًا",
      "WEEKLY_other": "أسبوع",
      "MONTHLY_zero": "شهر",
      "MONTHLY_one": "شهر",
      "MONTHLY_two": "شهران",
      "MONTHLY_few": "أشهر",
      "MONTHLY_many": "شهرًا",
      "MONTHLY_other": "شهر",
      "QUARTERLY_zero": "ربع سنة",
      "QUARTERLY_one": "ربع سنة",
      "QUARTERLY_two": "ربعا سنة",
      "QUARTERLY_few": "أرباع سنة",
      "QUARTERLY_many": "ربع سنة",
      "QUARTERLY_other": "ربع سنة",
      "YEARLY_zero": "سنة",
      "YEARLY_one": "سنة",
      "YEARLY_two": "سنتان",
      "YEARLY_few": "سنوات",
      "YEARLY_many": "سنة",
      "YEARLY_other": "سنة"
    },
    "frequency": {
      "WEEKLY": "أسبوعيًا",
      "MONTHLY": "شهريًا",
      "QUARTERLY": "ربع سنوي",
      "YEARLY": "سنويًا"
    },
    "status": {
      "ACTIVE": "نشط",
      "PAUSED": "موقوف مؤقتًا",
      "ENDED": "منتهٍ"
    },
    "occurrence": {
      "PENDING": "للمراجعة",
      "SKIPPED": "متخطى"
    },
    "sections": {
      "schedule": "الجدول",
      "scheduleHint": "متى يتكرر، وما الذي يحدث في كل موعد.",
      "amount": "المبلغ في كل مرة",
      "history": "المواعيد حتى الآن"
    },
    "fields": {
      "name": "الاسم",
      "frequency": "يتكرر",
      "interval": "كل",
      "dayOfMonth": "في اليوم",
      "lastDay": "آخر يوم من الشهر",
      "startDate": "يبدأ في",
      "ends": "ينتهي",
      "endDate": "تاريخ الانتهاء",
      "maxOccurrences": "عدد المرات",
      "mode": "في كل موعد",
      "repeats": "يتكرر",
      "next": "الموعد التالي",
      "eachTime": "في كل مرة",
      "comingUp": "القادم",
      "lastDate": "آخر موعد"
    },
    "hints": {
      "name": "كيف يظهر في القوائم، مثل «إيجار المكتب».",
      "dayOfMonth": "الأشهر التي ليس فيها هذا اليوم تستخدم آخر يوم فيها.",
      "startLinked": "تاريخ المصروف: فهو الموعد الأول."
    },
    "ends": {
      "never": "أبدًا",
      "date": "في تاريخ",
      "count": "بعد عدد من المرات"
    },
    "mode": {
      "review": "انتظار مراجعتي",
      "reviewHint": "ينتظر كل موعد في «المتكررة» حتى ترحّله (ويمكنك تغيير المبلغ) أو تتخطاه.",
      "post": "الترحيل تلقائيًا",
      "postHint": "يُسجَّل كل موعد ويُرحَّل مصروفًا من الحساب أعلاه."
    },
    "preview": {
      "title": "المواعيد التالية",
      "none": "لا مواعيد قادمة بهذا الجدول.",
      "reviewNow_zero": "لا مواعيد فائتة.",
      "reviewNow_one": "الحفظ يضع موعدًا فائتًا واحدًا للمراجعة.",
      "reviewNow_two": "الحفظ يضع موعدين فائتين للمراجعة.",
      "reviewNow_few": "الحفظ يضع {{n}} مواعيد فائتة للمراجعة.",
      "reviewNow_many": "الحفظ يضع {{n}} موعدًا فائتًا للمراجعة.",
      "reviewNow_other": "الحفظ يضع {{n}} موعد فائت للمراجعة.",
      "postsNow_zero": "لا مواعيد فائتة.",
      "postsNow_one": "الحفظ يرحّل مصروفًا واحدًا عن موعد فائت.",
      "postsNow_two": "الحفظ يرحّل مصروفين عن موعدين فائتين.",
      "postsNow_few": "الحفظ يرحّل {{n}} مصروفات عن مواعيد فائتة.",
      "postsNow_many": "الحفظ يرحّل {{n}} مصروفًا عن مواعيد فائتة.",
      "postsNow_other": "الحفظ يرحّل {{n}} مصروف عن مواعيد فائتة."
    },
    "source": {
      "title": "مبني على مصروف",
      "label": "احتسب هذا المصروف الموعد الأول:",
      "linked": "يبقى كما هو ويبدأ به الجدول في {{date}}، وتليه المواعيد التالية.",
      "unlinked": "يبقى المصروف منفصلًا؛ اختر متى يبدأ الجدول."
    },
    "repeat": {
      "title": "التكرار",
      "label": "التكرار شهريًا",
      "hint": "اجعل هذا المصروف أول مصروف متكرر شهريًا، وكل موعد ينتظر مراجعتك.",
      "next": "التالي في {{date}} وينتظر مراجعتك. غيّر الجدول من «المتكررة».",
      "failed": "حُفظ {{number}} لكن تعذّر جعله متكررًا. استخدم «اجعله متكررًا» عليه."
    },
    "pending": {
      "title": "بانتظار المراجعة",
      "hint": "رحّل كل واحد مصروفًا (ويمكنك تغيير المبلغ أولًا) أو تخطَّه."
    },
    "actions": {
      "edit": "تعديل",
      "run": "تشغيل الآن",
      "pause": "إيقاف مؤقت",
      "resume": "استئناف",
      "end": "إنهاء",
      "delete": "حذف",
      "post": "ترحيل",
      "skip": "تخطي"
    },
    "post": {
      "title": "ترحيل {{name}}",
      "body": "يسجّل هذا المصروف ويرحّله من حساب النقد أو البنك.",
      "confirm": "ترحيل المصروف"
    },
    "skip": {
      "title": "تخطي {{date}}؟",
      "body": "لن يُسجَّل مصروف لهذا الموعد، ويستمر الجدول.",
      "confirm": "تخطي الموعد"
    },
    "end": {
      "title": "إنهاء هذا المصروف المتكرر؟",
      "body": "لن تُنشأ مواعيد أخرى. تبقى المواعيد التي تنتظر المراجعة، وتُحفظ المصروفات التي أُنشئت.",
      "confirm": "إنهاؤه"
    },
    "delete": {
      "title": "حذف هذا المصروف المتكرر؟",
      "body": "لم يُنشأ منه شيء بعد، لذا يُحذف نهائيًا.",
      "confirm": "حذف"
    },
    "lastError": {
      "title": "تعذّر إنشاء المصروف الأخير",
      "body": "رُفض مصروف {{date}} في {{at}}. تُعاد المحاولة كل ليلة؛ عدّل المصروف المتكرر لإصلاحه."
    },
    "conflict": {
      "title": "غيّر شخص آخر هذا المصروف المتكرر",
      "body": "أعد تحميله لترى تغييراته، ثم أجرِ تغييراتك من جديد."
    },
    "empty": {
      "title": "لا مصروفات متكررة بعد",
      "body": "أعدّ الإيجار والاشتراكات وأي مصروف يتكرر، مرة واحدة.",
      "filteredTitle": "لا مصروفات متكررة مطابقة"
    },
    "toast": {
      "created": "تم إعداد {{name}}",
      "updated": "حُفظ المصروف المتكرر",
      "deleted": "حُذف {{name}}",
      "pause": "أُوقف مؤقتًا",
      "resume": "استؤنف",
      "end": "انتهى",
      "run": "تم",
      "ranPosted": "رُحّل مصروف {{date}}",
      "ranReview": "مصروف {{date}} ينتظر مراجعتك",
      "posted": "رُحّل {{number}}",
      "skipped": "تم تخطي الموعد"
    },
    "errors": {
      "RECURRING_ENDED": "انتهى هذا المصروف المتكرر: لا يمكن تعديله أو تشغيله.",
      "RECURRING_PAUSED": "هذا المصروف المتكرر موقوف مؤقتًا. استأنفه أولًا.",
      "RECURRING_NOT_PAUSED": "لا يُستأنف إلا مصروف متكرر موقوف مؤقتًا.",
      "IN_USE": "أُنشئت منه مصروفات، فلا يمكن حذفه. أنهِه بدلًا من ذلك."
    }
  }
}
